import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

import { TranslationModule } from '@lib/translation';
import { SnBadgeModule } from '@lib/ui/badge';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { SnMenuModule } from '@lib/ui/menu';
import { SnTooltipModule } from '@lib/ui/tooltip';

import { SnActionListComponent, SnActionListItemComponent } from './components';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    RouterModule,
    // Libs
    SnMenuModule,
    SnIconModule,
    SnBadgeModule,
    SnButtonModule,
    SnTooltipModule,
    MatButtonModule,
    TranslationModule,
  ],
  exports: [SnActionListComponent],
  declarations: [SnActionListComponent, SnActionListItemComponent],
})
export class SnActionsModule {}
